/**
 * stainedGlass — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const stainedGlassPack: ToilePack = {
    slug: 'stained-glass',
    category: 'stainedglass',
    name: 'Stained glass patterns',
    tagline: tagline('panels', 'designs', 'treatments'),
    chips: chips('designs', 'treatments'),
    ratio: SQUARE,
    readings: [
        {key: 'hummingbird', label: 'Hummingbird', subject: 'a hummingbird hovering at a trumpet flower'},
        {key: 'rosewindow', label: 'Rose window', subject: 'a circular rose window of radiating petals and tracery'},
        {key: 'mission', label: 'Mission landscape', subject: 'hills, a lone pine and a low sun'},
    ],
    styles: [
        {key: 'template', label: 'Cutting template', style: 'printable cutting template, closed cells', palette: 'black line on pure white', framing: 'flat, straight on, cuttable pieces'},
        {key: 'leaded', label: 'Leaded panel', style: 'finished leaded glass, backlit panes', palette: 'saturated translucent glass, dark came', framing: 'flat, straight on, centered'},
        {key: 'suncatcher', label: 'Suncatcher', style: 'copper-foiled suncatcher, soldered outline', palette: 'bevelled glass against a bright window', framing: 'hung, seen straight on'},
    ],
    directions: ['an iris instead', 'fewer, larger pieces', 'with a thicker lead line'],
}
